import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import '../static/images/SANDOS_logo_lg.png';
import '../static/images/MARCONFORT_logo_lg.png';
import '../static/images/PALMAIARESORTS_logo_lg.png';

import '../static/less/alert_mobile_land_scape.less';

const AlertMobileLand = ({ chain }, context) => (
  <div className="showAlertMobileLandscape">
    <img className="w-1/5 lg:w-auto" src={`/img/${chain}_logo_lg.png`}/>
    <p>{context.t('Please turn your device vertically for a better user experience. Thanks')}</p>
  </div>
);

AlertMobileLand.contextTypes = {
  t: PropTypes.func.isRequired,
};

export default connect((state) => ({
  chain: state.bookingFormState.chain,
}))(AlertMobileLand);
